<template>
  <v-card
    elevation="0"
    class="textLight--text rounded-xl"
    style="border: 1px solid #ebebeb"
  >
    <v-row class="pa-4" dense>
      <v-col cols="12">
        <h3 class="text-h6 font-weight-medium mb-2">
          {{ $t("organization.emailNotificationSettings") }}
        </h3>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        v-for="item in items"
        :key="item.key"
        class="py-3"
      >
        <v-row align="center" no-gutters dense>
          <v-col cols="9">
            <span class="subtitle-2 textLight--text">
              {{ $t(item.label) }}
            </span>
          </v-col>

          <v-col cols="3" class="text-end py-0">
            <v-switch
              v-model="localSettings[item.key]"
              inset
              color="success"
              :disabled="!isEdit"
              @change="emitUpdate"
              class="ma-0"
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: {
    settings: {
      type: Object,
      default: () => ({
        pendingBatchCompletionMail: false,
        subscriptionPlanReminderMail: false,
        trainingRegistrationReminderMail: false,
        trainingCertificateReminderMail: false,
        courseCompletionMail: false,
        otpMail: false,
        registrationInvitationMail: false,
        courseInvitationMail: false,
      }),
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      localSettings: { ...this.settings },
      items: [
        {
          key: "pendingBatchCompletionMail",
          label: "organization.pendingBatchCompletionMail",
        },
        {
          key: "subscriptionPlanReminderMail",
          label: "organization.subscriptionPlanReminderMail",
        },
        {
          key: "trainingRegistrationReminderMail",
          label: "organization.trainingRegistrationReminderMail",
        },
        {
          key: "trainingCertificateReminderMail",
          label: "organization.trainingCertificateReminderMail",
        },
        {
          key: "courseCompletionMail",
          label: "organization.courseCompletionMail",
        },
        {
          key: "otpMail",
          label: "organization.otpMail",
        },
        {
          key: "registrationInvitationMail",
          label: "organization.registrationInvitationMail",
        },
        {
          key: "courseInvitationMail",
          label: "organization.courseInvitationMail",
        },
        {
          key: "orderReceiptMail",
          label: "organization.orderReceiptMail",
        },
      ],
    };
  },
  watch: {
    settings: {
      immediate: true,
      handler(newVal) {
        this.localSettings = { ...newVal };
      },
    },
  },
  methods: {
    emitUpdate() {
      this.$emit("update:settings", { ...this.localSettings });
    },
  },
};
</script>
